<p>auth-frontend-{{appVersion}}</p>
